/* LJ Designs — ambient particle field (homepage hero) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var path = window.location.pathname;
    if (path !== '/' && path !== '') return;

    var sec = document.querySelector('#MainContent .shopify-section');
    if (!sec) return;

    sec.classList.add('lj-immersive');
    var canvas = document.createElement('canvas');
    canvas.className = 'lj-particles';
    canvas.setAttribute('aria-hidden', 'true');
    sec.prepend(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0;
    var H = 0;
    var particles = [];
    var mouse = { x: null, y: null };
    var LINK_DIST = 120;

    function makeParticle() {
      return {
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        r: Math.random() * 1.6 + 0.6,
        a: Math.random() * 0.5 + 0.25
      };
    }

    function resize() {
      var rect = sec.getBoundingClientRect();
      W = rect.width;
      H = rect.height;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var target = Math.round(Math.min(90, Math.max(30, (W * H) / 16000)));
      while (particles.length < target) particles.push(makeParticle());
      particles.length = target;
    }

    sec.addEventListener('mousemove', function (e) {
      var rect = sec.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    });
    sec.addEventListener('mouseleave', function () {
      mouse.x = null;
      mouse.y = null;
    });

    function step() {
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx;
        p.y += p.vy;

        if (mouse.x !== null) {
          var dxm = mouse.x - p.x;
          var dym = mouse.y - p.y;
          var dm = Math.sqrt(dxm * dxm + dym * dym);
          if (dm < 160 && dm > 0.001) {
            p.x += (dxm / dm) * 0.18;
            p.y += (dym / dm) * 0.18;
          }
        }

        if (p.x < -10) p.x = W + 10;
        if (p.x > W + 10) p.x = -10;
        if (p.y < -10) p.y = H + 10;
        if (p.y > H + 10) p.y = -10;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(147, 197, 253, ' + p.a + ')';
        ctx.fill();
      }

      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var dx = particles[a].x - particles[b].x;
          var dy = particles[a].y - particles[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < LINK_DIST) {
            var alpha = (1 - dist / LINK_DIST) * 0.18;
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.strokeStyle = 'rgba(59, 130, 246, ' + alpha + ')';
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(step);
    }

    resize();
    window.addEventListener('resize', resize);
    requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
